module.exports = __webpack_public_path__ + "img/new_index_cases19.e92457cc.png";